import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_EN_CURS,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_FINALITZADA } from '../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const peticioObtenirEstructuraIDadesEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_EN_CURS:
            return true;

        case ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioObtenirEstructuraIDadesEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/peticioObtenirEstructuraIDadesEnCurs.js